import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useUpdateDocument = ({ onSuccess } = {}) => {
  const queryClient = useQueryClient();
  const tenant = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (payload) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(`${tenant}/document`, payload);
      return response.data;
    },
    onSuccess: () => {
      toast.success("Document updated successfully");
      queryClient.invalidateQueries({ queryKey: ["patientDocuments"] });
      onSuccess?.();
    },
    onError: (error) => {
      const message = error?.response?.data?.message || "Failed to update document";
      toast.error(message);
    },
  });
};
